
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { Article, getRelatedProductArticles } from "@/data/articlesData";
import { FileText, ArrowRight } from "lucide-react";

interface RelatedArticlesProps {
  productType: string;
  title?: string;
  limit?: number;
  className?: string;
}

const RelatedArticles: React.FC<RelatedArticlesProps> = ({ 
  productType, 
  title = "Aiheeseen liittyviä artikkeleita", 
  limit = 3,
  className = ""
}) => {
  const articles = getRelatedProductArticles(productType, limit);
  
  if (!articles || articles.length === 0) {
    return null;
  }
  
  return (
    <Card className={`${className}`}>
      <CardHeader>
        <div className="flex items-center">
          <FileText className="h-5 w-5 mr-2 text-blue-600" />
          <CardTitle className="text-xl text-blue-700">{title}</CardTitle>
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {articles.map((article) => (
            <Link 
              key={article.id}
              to={`/artikkelit/${article.slug}`} 
              className="block bg-blue-50 p-4 rounded-lg hover:bg-blue-100 transition-colors"
            >
              <h3 className="font-medium text-blue-700 mb-2">{article.title}</h3>
              <p className="text-sm text-gray-700 mb-2 line-clamp-2">
                {article.summary}
              </p>
              <p className="text-blue-600 text-sm font-medium flex items-center">
                Lue lisää <ArrowRight size={14} className="ml-1" />
              </p>
            </Link>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default RelatedArticles;
